// extracted by mini-css-extract-plugin
module.exports = {"descriptionList":"ChangedLifeCycleAlert_descriptionList__30Azr"};